module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_9-4c22069257cd4b8e54fc2acfcfd072b2.jpg";